import { RoundUpState } from 'generated/types'

const screenInfo = {
  screen: 'roundUps',
  screen_name: 'roundUps',
}

const indexInfo = (indexposition: number, indexcount: number) => ({
  index_position: `${indexposition}`,
  index_count: `${indexcount}`,
})

export const roundUpsScreenViewed = () => ({
  object_name: 'roundUps',
  screen: 'roundUps',
  screen_name: 'roundUps',
})

export const roundUpContainerViewedFields = (
  roundUpState: RoundUpState,
  isInstant: boolean,
  indexposition: number,
  indexcount: number,
) => ({
  ...screenInfo,
  ...indexInfo(indexposition, indexcount),
  object_name: 'roundUpCell',
  style: isInstant ? 'instant' : roundUpState,
})

export const availableRoundUpButtonTappedFields = (
  indexposition: number,
  indexcount: number,
) => ({
  ...screenInfo,
  ...indexInfo(indexposition, indexcount),
  object_name: 'roundUpsAvailableRoundUp',
})

export const waitingRoundUpButtonTappedFields = (
  indexposition: number,
  indexcount: number,
) => ({
  ...screenInfo,
  ...indexInfo(indexposition, indexcount),
  object_name: 'roundUpsWaitingRoundUp',
})

export const confirmInvestmentModalViewedFields = (amount: number) => ({
  ...screenInfo,
  object_name: 'roundUpsConfirmInvestModal',
  amount: `${amount}`,
})

export const confirmInvestmentModalCancelTappedFields = (amount: number) => ({
  ...screenInfo,
  object_name: 'roundUpsConfirmInvestModalCancel',
  amount: `${amount}`,
})

export const confirmInvestmentModalConfirmTappedFields = (amount: number) => ({
  ...screenInfo,
  object_name: 'roundUpsConfirmInvestModalConfirm',
  amount: `${amount}`,
})

export const successModalViewedFields = () => ({
  ...screenInfo,
  object_name: 'roundUpsSuccessModal',
})

export const learnMoreButtonTappedFields = () => ({
  ...screenInfo,
  object_name: 'roundUpsBannerLearnMore',
})

export const learnMoreModalButtonTappedFields = () => ({
  ...screenInfo,
  object_name: 'roundUpsModalLearnMore',
})
